export default "__VITE_ASSET__CyRveTve__"